var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 28,
    viewBox: "0 0 2 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.643 27.2V.8",
    stroke: "#10365A"
  })));
}
export default SvgLineinline;